module.exports = __webpack_public_path__ + "img/Phoenix.189d6c91.png";